module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 col-lg-2"
  }, [_c('div', {
    staticClass: "text-right m-t-lg"
  }, [(_vm.loggedInUserIsCarrier) ? _c('router-link', {
    staticClass: "material-plus",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "",
      "data-original-title": "Create New Driver",
      "to": {
        name: 'drivers.create'
      }
    }
  }, [_vm._v("+")]) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8 col-sm-10 col-lg-10"
  }, [_c('h1', [_c('i', {
    staticClass: "far fa-id-card m-r-sm"
  }), _vm._v(" Drivers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-1caa2e56"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/drivers/IndexHeading.vue
// module id = 943
// module chunks = 0